module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-465-retro-min.bb5de583.jpg";